import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Box } from "@mui/material";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EditMyCertificate from "../components/Certifications/EditMyCertificate";
import SharedChart from "../components/orgchart/SharedChart";
import Auth from "../pages/Auth";
import CertificatesFormpage from "../pages/CertificatesFormpage";
import Certifications from "../pages/Certifications";
import DepartmentsTeams from "../pages/DepartmentsTeams";
import EmployeePage from "../pages/Employee";
import EmployeeFormPage from "../pages/EmployeeFormPage";
import OrganizationChartPage from "../pages/OrganizationChart";
import Profile from "../pages/Profile";
import ResetPassword from "../pages/ResetPassword";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

export const routes = [
  {
    name: "Employee",
    path: "/employee",
    ele: <EmployeePage />,
    icon: <PeopleIcon />,
    permissions: ["ADMIN"],
    isMenu: true,
  },
  {
    name: "Add Employee",
    path: "/employee/add",
    ele: <EmployeeFormPage />,
    icon: <PeopleIcon />,
    permissions: ["ADMIN"],
    isMenu: false,
  },
  {
    name: "Edit Employee",
    path: "/employee/edit/:id",
    ele: <EmployeeFormPage isEdit={true} />,
    icon: <PeopleIcon />,
    permissions: ["ADMIN"],
    isMenu: false,
  },
  {
    name: "Organization Chart",
    path: "/org_chart",
    ele: <OrganizationChartPage />,
    icon: <AccountTreeIcon />,
    permissions: ["ADMIN", "EMPLOYEE"],
    isMenu: true,
  },
  {
    name: "Departments and Teams",
    path: "/department_team",
    ele: <DepartmentsTeams />,
    icon: <BarChartIcon />,
    permissions: ["ADMIN", "EMPLOYEE"],
    isMenu: true,
  },
  {
    name: "Certifications",
    path: "/certifications",
    ele: <Certifications />,
    icon: <WorkspacePremiumIcon />,
    permissions: ["ADMIN", "EMPLOYEE"],
    isMenu: true,
  },

  {
    name: "Add Certifications",
    path: "/certifications/add",
    ele: <CertificatesFormpage />,
    icon: <WorkspacePremiumIcon />,
    permissions: ["ADMIN"],
    isMenu: false,
  },
  {
    name: "Edit Certifications",
    path: "/certification/edit/:id",
    ele: <CertificatesFormpage isEdit={true} />,
    icon: <WorkspacePremiumIcon />,
    permissions: ["ADMIN"],
    isMenu: false,
  },
  {
    name: "Edit My Certificate",
    path: "/certification/edit/my/:id",
    ele: <EditMyCertificate />,
    icon: <WorkspacePremiumIcon />,
    permissions: ["EMPLOYEE"],
    isMenu: false,
  },
  {
    name: "Edit Profile",
    path: "/profile",
    ele: <Profile />,
    icon: <WorkspacePremiumIcon />,
    permissions: ["EMPLOYEE"],
    isMenu: false,
  },
];

const RouteWrapper = () => {
  return (
    <Box>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Auth />
            </PublicRoute>
          }
        />
        <Route path="/reset-password/*" element={<ResetPassword />} />
        <Route path="/org_chart/shared/:id" element={<SharedChart />} />
        {routes?.length > 0 &&
          routes.map((route, index) => {
            if (route.isRedirectLink) {
              return null;
            } else {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <PrivateRoute
                      permissions={route.permissions}
                      title={route.name}
                    >
                      {route.ele}
                    </PrivateRoute>
                  }
                />
              );
            }
          })}
        <Route path="*" element={<Navigate to="/employee" />} />
      </Routes>
    </Box>
  );
};

export default RouteWrapper;
